module.exports = __webpack_public_path__ + "media/images/icons/dots-307acfb6da4077f135c6b4c818007d8c.svg";